var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-quicksearch-result" }, [
    _vm.resultsPageUrl
      ? _c("a", { attrs: { href: _vm.resultsPageUrl } }, [
          _c("h4", { staticClass: "global-search-result__header" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "global-search-result__header-count" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("search.buttons.showCategoryWithCount", {
                      count: _vm.result.count,
                    })
                  ) + " "
                ),
                _c("global-icon", { attrs: { icon: "arrow-right" } }),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "global-search-result__body" },
      [
        _vm._l(_vm.result.docs, function (resultItem) {
          return [
            _c("li", [
              _c("a", { attrs: { href: resultItem.href } }, [
                _vm._v(_vm._s(resultItem.title)),
              ]),
            ]),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }